import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index.js";
import Cookies from "js-cookie";

import Begin from '../views/Begin.vue'
import Test from '../components/containers/Navbar.vue'


import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Profile from '../views/Profile.vue'
import Balance from '../views/Balance.vue'
import History from '../views/History.vue'
import Invest from '../views/Invest.vue'
import PaymentReport from '../views/PaymentReport.vue'
import Withdraw from '../views/Withdraw.vue'
import WithdrawInvest from '../views/Withdrawinvest.vue'
import Chat from '../views/Chat.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Begin',
    component: Begin
  },
  {
    path: '/home',
    name: 'Test',
    component: Test,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {requiresAuth: true}
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {requiresAuth: true}
      },
      {
        path: '/balance/:id?',
        name: 'Balance',
        component: Balance,
        meta: {requiresAuth: true}
      },
      {
        path: '/history/:id?',
        name: 'History',
        props: true,
        component: History,
        meta: {requiresAuth: true}
      },
      
      {
        path: '/invest',
        name: 'Invest',
        component: Invest,
        meta: {requiresAuth: true}
      },
      {
        path: '/payment_report',
        name: 'PaymentReport',
        component: PaymentReport,
        meta: {requiresAuth: true}
      },
      {
        path: '/withdraw',
        name: 'Withdraw',
        component: Withdraw,
        meta: {requiresAuth: true}
      },
      {
        path: '/withdraw_invest',
        name: 'Withdraw_invest',
        component: WithdrawInvest,
        meta: {requiresAuth: true}
      },
      {
        path: '/chat',
        name: 'Chat',
        component: Chat,
        meta: {requiresAuth: true}
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
  
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) =>{
  const accessToken = Cookies.get("access_token");
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.status && !accessToken) {
    alert('Debe iniciar sesión para continuar')
    next("/login");
  }else if (store.state.status && accessToken){
    console.log('logged')
    next()
  }else{
    next()
  }
})

export default router
